import { render, staticRenderFns } from "./FreePropertyReport.vue?vue&type=template&id=9ae2858c&scoped=true&"
import script from "./FreePropertyReport.vue?vue&type=script&lang=ts&"
export * from "./FreePropertyReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae2858c",
  null
  
)

export default component.exports